import { getConfig } from '../Config/ApplicationConfig';
import { getExecutor } from '../Shared/HttpRequestExecutor';

export const updateDevice = (
    authoringSystem: string,
    authoringSystemForeignKey: string,
    prodaClientIdentifier: string,
    applicationName: string
): Promise<UpdateDeviceContracts.Response> =>
    getExecutor(getConfig().apiEndpoints.servicesAustralia).post<null, UpdateDeviceContracts.Response>(
        `api/v1/devices/${authoringSystem}/${authoringSystemForeignKey}/${prodaClientIdentifier}/${applicationName}/update`,
        null
    );

export namespace UpdateDeviceContracts {
    export interface Response {
        success: boolean;
        error: CheckDeviceTokenError;
    }

    export interface CheckDeviceTokenError {
        message: string;
        code: string;
    }
}
